import { useEffect } from "react";
import { InvestorHero } from "@/components/invest/InvestorHero";
import { InvestorNarrative } from "@/components/invest/InvestorNarrative";
import { InvestorOpportunity } from "@/components/invest/InvestorOpportunity";
import { FounderSection } from "@/components/invest/FounderSection";
import { InvestorInquiry } from "@/components/invest/InvestorInquiry";

export default function Invest() {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    let robots = document.querySelector('meta[name="robots"]');
    const createdRobots = !robots;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }

    document.title = "Vitura — Investor Briefing";
    description?.setAttribute("content", "Vitura Labs investor briefing: the daily performance shot, the five-day protocol, the founding team and current SAFE round.");
    robots.setAttribute("content", "noindex, nofollow");

    return () => {
      document.title = previousTitle;
      if (previousDescription) description?.setAttribute("content", previousDescription);
      if (createdRobots) robots?.remove();
    };
  }, []);

  return (
    <main className="min-h-screen bg-[color:var(--bg)] text-[color:var(--ink)]" data-testid="invest-page">
      <InvestorHero />
      <InvestorNarrative />
      <InvestorOpportunity />
      <FounderSection />
      <InvestorInquiry />
    </main>
  );
}